import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Hadımköy Koltuk Yıkama", path: "/arnavutkoy/hadimkoy-koltuk-yikama" },
  { label: "Hadımköy Battaniye Yıkama", path: "/arnavutkoy/hadimkoy-battaniye-yikama" },
  { label: "Taşoluk Koltuk Yıkama", path: "/arnavutkoy/taşoluk-koltuk-yikama" },
  { label: "Taşoluk Yorgan Yıkama", path: "/arnavutkoy/taşoluk-yorgan-yikama" },
  { label: "Bolluca Koltuk Yıkama", path: "/arnavutkoy/bolluca-koltuk-yikama" },
  { label: "Bolluca Perde Yıkama", path: "/arnavutkoy/bolluca-perde-yikama" },
  { label: "Hicret Mahallesi Koltuk Yıkama", path: "/arnavutkoy/hicret-koltuk-yikama" },
  { label: "Hicret Mahallesi Kuru Temizleme", path: "/arnavutkoy/hicret-kuru-temizleme" },
  { label: "Deliklikaya Koltuk Yıkama", path: "/arnavutkoy/deliklikaya-koltuk-yikama" },
  { label: "Deliklikaya Yerinde Yıkama", path: "/arnavutkoy/deliklikaya-yerinde-yikama" },
  { label: "Arnavutköy Merkez Koltuk Yıkama", path: "/arnavutkoy/merkez-koltuk-yikama" }
];

const ArnavutkoyServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          ARNAVUTKÖY HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ArnavutkoyServiceArea;
